import { AlertTriangleIcon } from 'lucide-react'

const ANOMALY_ROWS = [
  { category: 'Food and drink', outlierCount: 3 },
  { category: 'Rent and utilities', outlierCount: 0 },
  { category: 'Transportation', outlierCount: 2 },
  { category: 'General merchandise', outlierCount: 0 },
] as const

export const AnomaliesPreview = () => {
  return (
    <div className="flex h-full w-full flex-col justify-between gap-0.5 text-[10px]">
      {ANOMALY_ROWS.map((row) => (
        <div
          key={row.category}
          className="flex items-center justify-between gap-2 border-b py-1 last:border-b-0"
        >
          <span className="truncate font-medium text-foreground">
            {row.category}
          </span>
          {row.outlierCount === 0 ? (
            <span className="shrink-0 tabular-nums text-muted-foreground">
              0
            </span>
          ) : (
            <span className="inline-flex shrink-0 items-center gap-1 rounded-full border border-red-200 bg-red-50 px-1.5 py-0.5 font-semibold tabular-nums text-red-700">
              <AlertTriangleIcon className="h-2.5 w-2.5" />
              {row.outlierCount}
            </span>
          )}
        </div>
      ))}
    </div>
  )
}
